<template>
  <div id="app" class="scrollbar-definition">
    <div
      class="app-top"
      v-show="$route.path != '/centralYunnan' && $route.path != '/formWorkOne'"
    >
      <div class="app-name">
        <top-title></top-title>
      </div>
      <div class="app-nav">
        <div class="app-nav__box">
          <div
            v-for="(item, index) of navData"
            :key="index"
            class="app-nav-item"
            :class="activeNavLabel === item.label ? 'app-nav-item-active' : ''"
            @click="onNavClick(item)"
          >
            <el-badge :value="item.value" class="item">
              {{ item.label }}
            </el-badge>
          </div>
        </div>
      </div>
    </div>
    <div
      class="login"
      v-if="$route.path != '/centralYunnan' && $route.path != '/formWorkOne'"
    >
      <Login></Login>
    </div>
    <div
      id="breadcrumb-nav"
      v-show="
        breadcrumbNavDataStore.getData().length &&
        this.$route.path !== '/' &&
        this.$route.path !== '/needLand/index' &&
        $route.path != '/centralYunnan' &&
        $route.path != '/formWorkOne'
      "
      class="breadcrumb-nav"
    >
      <div class="breadcrumb-item">
        <span class="current-position">您当前的位置：</span>
        <el-breadcrumb separator-class="el-icon-d-arrow-right">
          <el-breadcrumb-item
            v-for="(item, index) of breadcrumbNavDataStore.getData()"
            :key="index"
            :to="{ path: item.path, query: item.query }"
          >
            <!-- @click.native="goUrl(item, index)" -->
            <span @click="breadcrumbNavDataStore.removeData(index + 1)">
              {{ item.name }}
            </span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <keep-alive include="industryList,landList,parkList,projectList">
      <router-view class="app-content" />
    </keep-alive>
     
    <!-- <keep-alive>
      <router-view
        class="app-content"
        v-show="$route.meta.keepAlive"
      ></router-view>
    </keep-alive>
       
    <router-view
      v-show="!$route.meta.keepAlive"
      class="app-content"
    ></router-view> -->
    <div
      class="app-foot"
      :style="{
        'flex-direction': $route.path === '/needLand/index' ? 'row' : 'column',
      }"
      v-show="
        $route.path != '/centralYunnan' &&
        $route.path != '/formWorkOne' &&
        $route.path != '/needLand/indexCopy'
      "
    >
      <!-- <div class="app-foot-item">
        <router-link to="/555" tag="span" class="app-foot-item-text">
          网站地图
        </router-link>
        |
        <router-link to="/555" tag="span" class="app-foot-item-text">
          联系我们
        </router-link>
        |
        <router-link to="/555" tag="span" class="app-foot-item-text">
          网站纠错
        </router-link>
      </div> -->
      <!-- <div class="app-foot-item">
        <span class="app-foot-item-text">电话：XXXX-XXXXXX</span>
        <span class="app-foot-item-text">QQ：XXXXXXXXXXXX</span>
        <span class="app-foot-item-text">网址：XXXXXXXXXXXXX</span>
      </div>
      <div class="app-foot-item">
        <span class="app-foot-item-text">地址：XXXXXXXXXXXXXXXXX</span>
      </div>-->
      <div class="app-name" style="height: 176px">
        <footTitle></footTitle>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbNavDataStore from "@/store/breadcrumbNavDataStore";
import TopTitle from "@/components/home/topTile";
import Login from "@/components/login/login";
import { infoFavoriteList, statisticsAdd } from "@/api/setting/investment.js";
import footTitle from "@/components/home/footTile";

export default {
  name: "App",
  components: { TopTitle, Login, footTitle },
  data() {
    return {
      navData: [
        { label: "首页", path: "/" },
        { label: "云上选地", path: "/needLand/indexCopy" },
        { label: "土地超市", path: "/land/list" },
        { label: "推介专场", path: "/promotion/list" },
        { label: "项目招商", path: "/project/list" },
        { label: "园区（开发区）", path: "/park/list" },
        { label: "行业动态", path: "/industry/list" },
        { label: "登录", path: "/mine", value: "" },
      ],
      activeNavLabel: undefined,
      breadcrumbNavDataStore,
      bgList: [
        require("./assets/images/bgimg/beijing3.jpeg"),
        require("./assets/images/bgimg/beijing4.jpeg"),
        require("./assets/images/bgimg/beijing9.jpg"),
        // require("./assets/images/bgimg/beijing11.jpeg"),
        require("./assets/images/bgimg/beijing13.jpg"),
        require("./assets/images/bgimg/beijing14.jpg"),
        // require("./assets/images/bgimg/beijing15.jpg"),
        // require("./assets/images/bgimg/beijing16.jpg"),
        require("./assets/images/bgimg/beijing17.jpg"),
        require("./assets/images/bgimg/beijing18.jpg"),
      ],
      bodyDom: "",
      timeInterval: "",
      form: {
        current: 1,
        size: 100,
      },
      include: [],
      fotterShow: true,
      clientWidth: document.body.clientWidth,
    };
  },
  created() {
    setTimeout(() => {
      for (let navDatum of this.navData) {
        if (navDatum.path === this.$route.path) {
          this.activeNavLabel = navDatum.label;
          return;
        } else {
          let data = sessionStorage.getItem("activeNavLabel");
          if (data) {
            this.activeNavLabel = data;
          }
        }
      }
    }, 500);
    if (systemConfig.access) {
      systemConfig.access = false;
      statisticsAdd().then((res) => {
        if (res.data.success) {
        }
      });
    }
    // this.navData[7].value=this.sessionStorage.getItem("total") ? this.sessionStorage.getItem("total") :"0"
  },
  watch: {
    $route(newValue) {
      for (let navDatum of this.navData) {
        if (navDatum.path === newValue.path) {
          this.activeNavLabel = navDatum.label;
        }
      }
    },
  },
  mounted() {
    // const initializeWidth1 = window.screen.width; //初始化网页宽度
    // if (initializeWidth1 < 1800) {
    //   document.body.style.zoom = "80%";
    // }
    this.bodyDom = document.getElementsByTagName("body");
    let len = this.bgList.length;
    let ran = Math.floor(Math.random() * len + 1);
    this.setBodyBg(this.bgList[ran - 1]);
    this.changeBg();
    this.$eventBus.on("total", (val) => {
      this.navData[7].value = val ? val : "";
    });
    this.$eventBus.on("Delete", () => {
      infoFavoriteList(this.form).then((res) => {
        if (res.data.success) {
          this.navData[7].value = res.data.data.total
            ? res.data.data.total
            : "";
        }
      });
    });
    this.$eventBus.on("isRefresh", () => {
      infoFavoriteList(this.form).then((res) => {
        if (res.data.success) {
          this.navData[7].value = res.data.data.total
            ? res.data.data.total
            : "";
        }
      });
    });
    this.$eventBus.on("logout", () => {
      this.navData[7].value = "";
      this.navData[7].label = "登录";
    });
    this.$eventBus.on("isLogin", () => {
      this.navData[7].label = "我的";
    });
  },
  methods: {
    // goUrl(item, index) {
    //   if (this.breadcrumbNavDataStore.state.length - 2 == index) {
    //     this.$router.go(-1);
    //     this.breadcrumbNavDataStore.removeData(index + 1);
    //   } else {
    //     this.$router.push({ path: item.path });
    //   }
    // },
    // 获取意向地块数量

    onNavClick(item) {
      //解决重复点击同一路由不刷新问题
      if (item.path === this.$route.path && item.path == "/") {
        this.$router.push({
          path: "/black",
          query: { path: item.path },
        });
        return;
      }
      this.$router.push({ path: item.path });
      this.activeNavLabel = item.label;
      sessionStorage.setItem("activeNavLabel", this.activeNavLabel);
    },
    // 定时切换背景图
    changeBg() {
      if (!this.timeInterval) {
        this.timeInterval = setInterval(() => {
          // 1分钟切换一次
          let len = this.bgList.length;
          let ran = Math.floor(Math.random() * len + 1); // 随机数 1-3
          this.setBodyBg(this.bgList[ran - 1]);
        }, 60000);
      }
    },
    //设置样式
    setBodyBg(url) {
      this.bodyDom[0].background = url;
    },
  },
  destroyed() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  },
};
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  color: #333333;
  position: relative;
}

#app {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

body {
  /* background-image: url("./assets/images/bgimg/beijing.png");*/
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: top center;
  background-size: cover;
}
@media screen and (max-width: 1600px) {
  :root {
    font-size: 14px;
  }
  .el-popover,
  .el-cascader__dropdown,
  .el-select-dropdown,
  .el-tooltip__popper {
    zoom: 0.8;
  }
}
@media screen and (min-width: 1600px) {
  :root {
    font-size: 16px;
  }
}

.app-top {
  /*  background-image: url("~@/assets/images/app/banner.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;*/
}

.app-name {
  height: 150px;
  font-size: 34px;
  padding: 0 20%;
}

.app-nav {
  background: linear-gradient(90deg, #4196e4c9, #1f42a1de);
  display: flex;
  justify-content: center;
  align-items: center;
}

.app-nav__box {
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  /* column-gap: 20px; */
}

.app-nav-item {
  color: white;
  line-height: 50px;
  padding: 0 20px;
  text-align: center;
  cursor: pointer;
}

.app-nav-item-active {
  background-color: #00000030;
}

.breadcrumb-nav {
  width: 60%;
  margin: 0 auto;
  padding: 10px 0;
  display: flex;
  height: 20px;
  /* line-height: 14px; */
  font-size: 14px;
  align-items: center;
  background: #fff;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  padding-left: 53px;
}

.app-content {
  flex-grow: 1;
  /* padding: 1px 0; */
}

.app-foot {
  /* background: linear-gradient(90deg, #2785e0, #0d2fb5); */
  background: #2756af;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  font-size: 12px;
  padding: 10px 0;
  /* cursor: pointer; */
}

.app-foot-item {
  display: flex;
  justify-content: center;
  padding: 2px 0;
}

.app-foot-item-text {
  padding: 0 8px;
}

/*用于将行政区划变成 文字可选中的  加上 theder*/
.theder .el-cascader-node > .el-radio {
  opacity: 0 !important;
  width: 150px !important;
  height: 100% !important;
  position: absolute !important;
}

::v-deep .el-breadcrumb {
  line-height: 19px !important;
}

.login {
  width: 340px;
  height: 26px;
  position: absolute;
  top: 4%;
  right: 5%;
}
.el-tooltip__popper{
  zoom:  0 !important;
}
</style>
